import { WasteReturnRegFieldKeys } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

/** Mirrors backend `WasteReturnListSourceDetector.ResolvePrimaryValueField` for code-based catalogue rows. */
export function resolvePrimaryValueField(regFieldKey: string): string {
    switch (regFieldKey) {
        case WasteReturnRegFieldKeys.Ewc:
        case WasteReturnRegFieldKeys.EaDrReceived:
        case WasteReturnRegFieldKeys.EaDrRemoved:
        case WasteReturnRegFieldKeys.Geography:
            return "code";
        case WasteReturnRegFieldKeys.TechnicalCompetence:
            return "code";
        default:
            return "description";
    }
}
